<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.65988 13.6523L10.1547 8.5036C9.57914 8.31176 7.96136 7.99058 6.1259 7.81295C4.34173 7.64029 9.92446 6.08634 10.7878 6.37411C10.8345 6.23393 10.8694 6.13371 10.8951 6.06319C10.9296 5.96842 11.0261 5.93405 11.1224 5.96394L12.427 6.36881C12.5414 6.40433 12.6095 6.52167 12.5835 6.63862L12.5144 6.94964C13.3264 7.53218 15.1293 9.23551 15.5465 10.6696C15.5912 10.8233 15.4308 10.9372 15.2887 10.8636C13.508 9.94182 12.5947 9.43878 12.1616 9.20026C11.9448 9.08084 11.8484 9.02774 11.8237 9.02158L9.89125 14.1013C9.84603 14.2202 9.71298 14.2798 9.59413 14.2346L8.79902 13.9317C8.68699 13.889 8.62646 13.7675 8.65988 13.6523Z" fill="currentColor" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 6.3741C2.5 3.95835 4.45835 2 6.8741 2H14.1259C16.5416 2 18.5 3.95835 18.5 6.3741V13.6259C18.5 16.0416 16.5416 18 14.1259 18H6.8741C4.45835 18 2.5 16.0416 2.5 13.6259V6.3741ZM6.8741 3.15108H14.1259C15.9059 3.15108 17.3489 4.59408 17.3489 6.3741V13.6259C17.3489 15.4059 15.9059 16.8489 14.1259 16.8489H6.8741C5.09408 16.8489 3.65108 15.4059 3.65108 13.6259V6.3741C3.65108 4.59408 5.09408 3.15108 6.8741 3.15108Z"
      fill="currentColor"
    />
  </svg>
</template>
